/* eslint-disable react/no-this-in-sfc */

import React from 'react';
import { Button } from 'antd';
import { DoubleLeftOutlined, DoubleRightOutlined } from '@ant-design/icons';

import './filter-sidebar.css';

export default function () {
    const { children, isReportEmpty, user, overrideTitle } = this.props;
    const { filterSidebar } = this.state;

    return (
        <div
            data-test="component-filter-sidebar"
            className={`filter  sidebar-is-protrusive ${
                (filterSidebar || isReportEmpty) ? 'sidebar-is-active' : ''
            }`}>
            <div className="filter__mobile-nav">
                <Button
                    className="btn btn-white"
                    onClick={this.toggleFilterSidebar}
                >
                    {filterSidebar ? <DoubleLeftOutlined /> : <DoubleRightOutlined />}
                </Button>
            </div>
            <div className={`filter__sidebar${user?.userCompany?.current_alert ? '-with-banner' : ''}`}>
                <div className="filter__sidebar-inner">
                    <div className="sidebar__header">
                        <div className="with-funnel">
                            <div className='filter-title'>
                                {overrideTitle || 'Filters'}
                            </div>
                                <Button
                                    className="btn btn-empty"
                                    onClick={this.toggleFilterSidebar}
                                    data-testid='filter-sidebar_collapse-btn'
                                >
                                    {filterSidebar ? <DoubleLeftOutlined /> : <DoubleRightOutlined />}
                                </Button>
                        </div>
                    </div>
                    {filterSidebar || isReportEmpty ? (
                        <div className="filter__sidebar-data__with-header">{children}</div>
                    ) : null}
                </div>
            </div>
        </div>
    );
}
